// Generated by CoffeeScript 1.12.7
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('models/survey',['require','underscore','backbone'],function(require) {
  var Model, Survey, _;
  _ = require('underscore');
  Model = require('backbone').Model;
  return Survey = (function(superClass) {
    extend(Survey, superClass);

    function Survey() {
      return Survey.__super__.constructor.apply(this, arguments);
    }

    Survey.DISQUALIFY_EVENT = 'disqualify';

    Survey.prototype.idAttribute = "_id";

    Survey.prototype.urlRoot = function() {
      return GLOBALS.uris.api + "/survey";
    };

    Survey.prototype.defaults = {
      branding: {
        logo: null,
        url: "https://surveyplanet.com"
      },
      theme: null,
      success: {
        alignment: 'center'
      },
      welcome: {
        alignment: 'center'
      }
    };

    Survey.prototype.parse = function(response, options) {
      return response.data;
    };

    Survey.prototype.hasBranches = function() {
      var questions;
      questions = this.get('questions');
      if (!questions || !questions.length) {
        return false;
      }
      return _.some(questions, function(question) {
        return question.branches && question.branches.length;
      });
    };

    Survey.prototype.initialize = function() {};

    return Survey;

  })(Model);
});

